import axios from "axios";
import { getByAgentId } from "./agentsCatalogService";

export const GET_BY_SLUG = "cases";
export const SAVE = "cases";
export const UPDATE = "cases";
export const DELETE = "cases";

// Parche temporal: backend resuelve la relacion case.agent contra la PK del catalogo,
// pero tra_cases.agent_id guarda el business id (VARCHAR). Eso devuelve un agente
// equivocado cuando el business id colisiona numericamente con otra PK.
// Mientras backend cambia el @JoinColumn a referencedColumnName="agent_id",
// re-resolvemos aqui el agente por business id y reemplazamos data.agent.
export let getBySlug = async function (slug) {
    const response = await axios.get(`${GET_BY_SLUG}/${slug}`);
    const businessAgentId = response?.data?.agentId;
    if (businessAgentId) {
        try {
            const agentResponse = await getByAgentId(businessAgentId);
            if (agentResponse?.data) {
                response.data = { ...response.data, agent: agentResponse.data };
            }
        } catch (error) {
            // Si la re-resolucion falla, dejamos el agente original (mejor mostrar
            // algo, aunque sea incorrecto, que dejar el header vacio).
            console.warn(`No se pudo re-resolver agente ${businessAgentId}:`, error?.message);
        }
    }
    return response;
}

export let save = function (data) {
    return axios.post(SAVE, data);
}

export function update(data, id) {
    return axios.put(`${UPDATE}/${id}`, data);
}

export function destroy(roleId) {
    return axios.delete(`${DELETE}/${roleId}`);
}
